function escapeHtml(value) {
  return String(value ?? '').replaceAll('&', '&amp;').replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}

export const UNASSIGN_DRIVER_LABEL = 'Unassigned';

/**
 * The name a typed driver box saves (Alan, 2026-09-27: "整个流程都是直接可以手动操作
 * 的"). A name that is one of the listed drivers, however it was cased, saves as that
 * driver's own spelling - the release resolves drivers by name, so "eric" saved as
 * typed would be a different person from "Eric". Anything else saves as typed: the
 * leg then waits for a driver account under that name rather than being refused.
 */
export function typedDriverName(value, drivers = []) {
  const typed = String(value ?? '').trim().replace(/\s+/g, ' ');
  if (!typed) return '';
  const match = normalizeDashboardDrivers(drivers)
    .find(({ fullName }) => fullName.toLocaleLowerCase() === typed.toLocaleLowerCase());
  return match ? match.fullName : typed;
}

export function dashboardDriverTypedMarkup(value = '') {
  return `<input class="dashboard-driver-typed" type="text" data-driver-typed value="${escapeHtml(String(value ?? '').trim())}" placeholder="输入名字，回车保存 · Type a name, Enter" aria-label="Type a driver name" autocomplete="off" spellcheck="false">`;
}

export function normalizeDashboardDrivers(value) {
  const seen = new Set();
  return (Array.isArray(value) ? value : [])
    .flatMap((driver) => {
      const id = String(driver?.id || '').trim();
      const fullName = String(driver?.fullName || driver?.full_name || '').trim();
      if (!id || !fullName || seen.has(id)) return [];
      seen.add(id);
      return [{ id, fullName }];
    })
    .sort((left, right) => left.fullName.localeCompare(right.fullName, undefined, {
      sensitivity: 'base', numeric: true,
    }));
}

export function dashboardDriverOptionsMarkup({
  label = 'Driver', selectedName = '', drivers = [], state = 'ready',
} = {}) {
  const normalized = normalizeDashboardDrivers(drivers);
  if (state === 'loading') {
    return '<div class="dashboard-driver-options dashboard-driver-options--loading" role="status" aria-live="polite"><span class="dashboard-driver-loading-dot" aria-hidden="true"></span><span>Loading drivers&hellip;</span></div>';
  }
  if (state === 'error') {
    return '<div class="dashboard-driver-options dashboard-driver-options--message" role="alert"><span>Drivers could not be loaded.</span><button type="button" data-driver-retry>Retry</button></div>';
  }
  if (!normalized.length) {
    return '<div class="dashboard-driver-options dashboard-driver-options--message" role="status"><span>No active drivers are available.</span></div>';
  }
  const selected = String(selectedName || '').trim();
  // Dispatch has to be able to take a driver back off a job when something goes
  // wrong, so the list opens with a blank row that clears the assignment
  // (Alan, 2026-08-01). It is selected when the cell is currently empty, which also
  // gives the menu an honest "nobody assigned" state.
  const clearRow = `<button type="button" class="dashboard-driver-option dashboard-driver-option--clear${selected ? '' : ' is-selected'}" role="option" aria-selected="${!selected}" data-driver-option-id="" data-driver-option-name=""><span>${escapeHtml(UNASSIGN_DRIVER_LABEL)}</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3.2 8.2 2.8 2.7 6.6-6.5"/></svg></button>`;
  return `<div class="dashboard-driver-options" role="listbox" aria-label="${escapeHtml(label)}">${clearRow}${normalized.map((driver) => {
    const isSelected = driver.fullName === selected;
    return `<button type="button" class="dashboard-driver-option${isSelected ? ' is-selected' : ''}" role="option" aria-selected="${isSelected}" data-driver-option-id="${escapeHtml(driver.id)}" data-driver-option-name="${escapeHtml(driver.fullName)}"><span>${escapeHtml(driver.fullName)}</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3.2 8.2 2.8 2.7 6.6-6.5"/></svg></button>`;
  }).join('')}</div>`;
}
